// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"89":"b901abf4","504":"3f614aa5","601":"83822266"}[chunkId] + ".css";
};